import { getPowerAroundV2 } from '../../apis/map.api'
import { Point, PowerResource } from '../../contract/map'
import { useComponentStore } from '../../nsh5/localStores/component'

/**
 * 获取当前选中位置周边的换电站
 * @param {number} distance 搜索范围, 单位米
 */
export const getSwapAroundSelectedLoc = async (
  currentLocation: Point,
  zoomLevel: number,
  distance: number
) => {
  const componentStore = useComponentStore()
  let swaps: PowerResource[] = []
  if (currentLocation && componentStore.getPowerSwapInFilter()) {
    // gcj
    const loc = { lng: currentLocation.lng, lat: currentLocation.lat } // gcj
    const res = await getPowerAroundV2(
      zoomLevel,
      {
        'recharge|ps': null,
        // recharge: {
        //   resource_types: 'PS',
        // },
      },
      loc,
      distance
    )
    if (res.isValid() && res.data?.powers) {
      swaps = res.data.powers
    }
  }
  return swaps
}
